<template>
    <v-card>
        <v-card-title>
            <v-icon left>{{ icon }}</v-icon>
            {{ title }}
        </v-card-title>
        
        <v-card-text>
            <div class="d-flex justify-space-between mb-2">
                <span>{{ current }} / {{ limit === null ? '∞' : limit }}</span>
                <span v-if="limit !== null" :class="progressColorClass">
                    {{ progressPercentage }}%
                </span>
            </div>
            
            <v-progress-linear
                v-if="limit !== null"
                :value="progressPercentage"
                :color="progressColor"
                height="10"
                rounded
            ></v-progress-linear>
            
            <div v-else class="text-center">
                <v-chip color="success" small>
                    <v-icon left small>mdi-infinity</v-icon>
                    Ilimitado
                </v-chip>
            </div>
            
            <v-alert
                v-if="isNearLimit"
                type="warning"
                dense
                text
                class="mt-3"
            >
                ⚠️ Você está próximo do limite
            </v-alert>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'LimitProgressCard',
    
    props: {
        title: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            default: 'mdi-chart-line'
        },
        current: {
            type: Number,
            required: true
        },
        limit: {
            type: Number,
            default: null
        }
    },
    
    computed: {
        progressPercentage() {
            if (this.limit === null || this.limit === 0) return 0;
            return Math.min(100, Math.round((this.current / this.limit) * 100));
        },
        
        progressColor() {
            if (this.progressPercentage >= 90) return 'error';
            if (this.progressPercentage >= 75) return 'warning';
            return 'success';
        },
        
        progressColorClass() {
            return `${this.progressColor}--text font-weight-bold`;
        },
        
        isNearLimit() {
            return this.limit !== null && this.progressPercentage >= 80;
        }
    }
};
</script>
